/**
 * Phone number validation for Swedish and Norwegian numbers.
 *
 * Applies AFTER stripping spaces and hyphens from input
 * (callers are expected to run `val.replace(/[\s-]/g, '')` first).
 *
 * Swedish landlines follow a scaling rule:
 *   - 2-digit area code (e.g. 08): local number 5–8 digits → total 7–10 digits
 *   - 3-digit area code (e.g. 031, 040): local number 5–7 digits → total 8–10 digits
 *   - 4-digit area code (e.g. 0920): local number 5–6 digits → total 9–10 digits
 * After stripping the trunk prefix 0 (or +46/0046) the remaining block is always 6–9 digits.
 * Landline area codes start with 1, 2, 3, 4, 5, 6, 8, or 9 — digit 7 is reserved for mobile.
 *
 * Accepts:
 *   SE mobile:   07XXXXXXXX (10 digits)  |  +46 / 0046 + 7XXXXXXXX
 *   SE landline: 0[1-6,8-9]XXXXX–XXXXXXXX (7–10 digits)  |  +46 / 0046 + [1-6,8-9]XXXXX–XXXXXXXX
 *   NO numbers:  [2-9]XXXXXXX (8 digits)  |  +47 / 0047 + 8 digits
 */
export const SE_NO_PHONE_REGEX =
  /^((\+46|0046)([1-689]\d{5,8}|7\d{8})|0[1-689]\d{5,8}|07\d{8}|(\+47|0047)\d{8}|[2-9]\d{7})$/;
